// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__1yXmH","header":"PatientQuestionnaire_header__35dPP","info":"PatientQuestionnaire_info__2h4xC"};